import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import AppRoutes from './routes';
import { loadScript } from '../FTTX/utills';
import AppProvider from './routes/AppProvider';
import Loader from '../Shared/Components/Loader/Loader';
import { ga4Initialize } from '../Shared/helper/google-analytics';
import HelpFloatingWidget from '../FTTX/component/HelpFloatWidget/HelpFloatWidget';

const App = () => {
  // useEffect(() => {
  //   requestIdleCallback(async () => {
  //     await loadScript("/assets/js/jquery-3.7.1.min.js");
  //     await loadScript("/assets/js/jquery-ui.js");
  //     await loadScript("/assets/js/custom.min.js");
  //   });
  // }, []);

  useEffect(() => {
    const removeLoader = () => {
      const loader = document.getElementById("initial-loader");
      if (loader) {
        loader.style.opacity = "0";
        loader.style.pointerEvents = 'none';
      }
    }
    ga4Initialize();
    if (document.readyState !== 'loading') {
      removeLoader();
    } else {
      document.addEventListener("DOMContentLoaded", removeLoader);
    }
    return () => document.removeEventListener("DOMContentLoaded", removeLoader);
  }, []);

  return (
    <Router useTransitions={false}>
      <AppProvider>
        <AppRoutes />
        <Loader />
        <HelpFloatingWidget />
      </AppProvider>
    </Router>
  )
}

export default App